import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=42081486&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style1 from "./Create.vue?vue&type=style&index=1&id=42081486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42081486",
  null
  
)

export default component.exports